import type { PhoneCountry, PhoneInputProps } from '../phone-input';

import { Controller, useFormContext } from 'react-hook-form';

import { PhoneInput } from '../phone-input';

// ----------------------------------------------------------------------

export type RHFPhoneInputProps = Omit<
  PhoneInputProps,
  'value' | 'onChange' | 'country' | 'defaultCountry'
> & {
  name: string;
  forceCountry?: PhoneCountry;
};

export function RHFPhoneInput({
  name,
  helperText,
  forceCountry = 'IN',
  ...other
}: RHFPhoneInputProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <PhoneInput
          {...field}
          fullWidth
          country={forceCountry}
          error={!!error}
          helperText={error?.message ?? helperText}
          {...other}
        />
      )}
    />
  );
}
